import { MijnRoute } from '../../mijn-navigatie.model';

export const BUDGET_DETAILS: MijnRoute = {
    path: 'details',
    navigationEvent: 'toBudgetDetails',
    regex: /^\/budgetten\/details$/,
    webcomponent: 'mijn-budget-webcomponent',
    internalPath: '/details'
};
